import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ItemFormulaGeral } from '../models/item-formula-geral';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ItemFormulaGeralService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarItens(tipo: number) {
    return this.http.get<ItemFormulaGeral[]>(globals.apiUrl + '/api/ItemFormulaGeral/Lista', {
      params: new HttpParams()
        .set('tipo', tipo.toString())
    });
  }

  consultarItemFormulaGeralComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/ItemFormulaGeral/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(idItem) {
    return this.http.get<any>(globals.apiUrl + '/api/ItemFormulaGeral/Buscar',
      { params: new HttpParams().set('id', idItem) });
  }

  salvar(item: ItemFormulaGeral) {
    return this.http.post(globals.apiUrl + '/api/ItemFormulaGeral/Salvar', item);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ItemFormulaGeral/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
